import { DEFAULT_TAB_FAVICON, DEFAULT_TAB_TITLE } from '@distribusion/portal-lib/constants';
import { MS_IN_MINUTE, MS_IN_SECOND } from '@distribusion/portal-lib/constants';
import config from 'config';
import { DISTRIBUSION_PRIMARY_LOGO, RAILAGENT_LOGO } from 'constants/common';

export const JWT_TOKEN_TTL_MS = 10 * MS_IN_MINUTE; // 10 minutes
export const JWT_TOKEN_REFRESH_INTERVAL_MS = JWT_TOKEN_TTL_MS - 1 * MS_IN_MINUTE; // 9 minutes
export const REFETCH_ON_USE_SESSION_ERROR_INTERVAL_MS = 5 * MS_IN_SECOND; // 5 seconds

export const AUTH_CONFIG = {
  distribusion: {
    origin: config.distribusion.url,
    logoSrc: DISTRIBUSION_PRIMARY_LOGO,
    hasSSO: true,
    tabFaviconUrl: DEFAULT_TAB_FAVICON,
    tabTitle: DEFAULT_TAB_TITLE,
    signupFormUrl: undefined as string,
  },
  railagent: {
    origin: config.amtrak.url,
    logoSrc: RAILAGENT_LOGO,
    hasSSO: true,
    tabFaviconUrl: '/railagent-favicon.ico',
    tabTitle: 'Railagent',
    signupFormUrl: config.amtrak.signupFormUrl,
  },
};
